import * as prodTypes from '../actionTypes';
const initialState = {
    loading: false,
    store: null,
    product: null,
    orderedProduct: null,
    storeCreated: false,
    productCreated: false,
    variantTableData: null,
};
export const storeReducer = (state = initialState, action) => {
    switch (action.type) {
        case prodTypes.CREATE_STORE:
            return { ...state, loading: true };
        case prodTypes.CREATE_STORE_SUCCESS:
            return { 
                ...state,
                loading: false,
                store: action.payload,
                storeCreated: true,
                productCreated: false 
            };
        case prodTypes.CREATE_STORE_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.GET_STORE:
            return { ...state, loading: true };
        case prodTypes.GET_STORE_SUCCESS:
            return { ...state, loading: false, store: action.payload };
        case prodTypes.GET_STORE_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.GET_ORDERED_PRODUCTS:
            return { ...state, loading: true };
        case prodTypes.GET_ORDERED_PRODUCTS_SUCCESS:
            return { ...state, loading: false, orderedProduct: action.payload };
        case prodTypes.GET_ORDERED_PRODUCTS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.ADD_TO_STORE:
            return { ...state, adding: true };
        case prodTypes.ADD_TO_STORE_SUCCESS:
            return {
                ...state,
                adding: false,
                store:  action.payload,
                storeCreated: false,
                productCreated: true
            };
        case prodTypes.ADD_TO_STORE_FAIL:
            return { ...state, adding: false, error: action.payload };

        case prodTypes.REMOVE_FROM_STORE:
            return { ...state, adding: true };
        case prodTypes.REMOVE_FROM_STORE_SUCCESS:
            return {
                ...state,
                adding: false,
                store: {
                    ...state.store,
                    products: action.payload
                }
            };
        case prodTypes.REMOVE_FROM_STORE_FAIL:
            return { ...state, removing: false, error: action.payload };

        case prodTypes.EDIT_STORE_PRODUCT:
            return { ...state, product: action.payload };

        case prodTypes.CLEAR_STORE_ACTIONS:
            return { ...state, storeCreated: false, productCreated: false };

        case prodTypes.UPDATE_VARIANT_TABLE:
            return { ...state, variantTableData: action.payload }

        default:
            return state;
    }
};
